<br />
<h2 class="p-form-layout01__item-title c-heading-2" [innerHTML]="'label.ticketingInformation' | staticMsg"></h2>
<div class="p-form-layout01">
  <div class="p-form-layout01__item">
    <div class="p-input-block01">
      <div class="p-input-block01__item">
        <form [formGroup]="ticketingRequestFormGroup">
          <div class="ticketing-container">
            <div *ngIf="contractSecName">
              <span class="p-input-block01__row-title" [innerHTML]="'label.departmentName' | staticMsg"></span>
              <br />
              <div class="p-input-block01__row-body-item">
                <span [innerHtml]="contractSecName"></span>
              </div>
            </div>

            <br />

            <span class="p-input-block01__row-title" [innerHTML]="'label.approver' | staticMsg"></span>
            <br />
            <div class="approver-block" *ngIf="currentApprover">
              <span class="centered-text" [innerHtml]="currentApprover"></span>
              <asw-button
                id="anabizShowApproverListBtn"
                type="secondary"
                size="xs"
                (click$)="showApproverList()"
                throttleClick
                >{{ 'label.approverChange' | staticMsg }}</asw-button
              >
            </div>
            <div
              class="approver-block-unselected"
              *ngIf="!currentApprover"
              (throttleClick$)="showApproverList()"
              aswThrottleClick
            >
              <span class="centered-text" [innerHTML]="'label.selectApprover' | staticMsg"></span>
            </div>
            <asw-validation-error
              *ngIf="approverError && !currentApprover"
              id="select_approver_error"
              [errorMessage]="approverError"
            ></asw-validation-error>
          </div>
          <br />
          <label
            for="biz-request-comment"
            class="p-input-block01__row-title"
            [innerHTML]="'label.comment' | staticMsg"
          ></label>
          <br />

          <textarea
            id="biz-request-comment"
            class="ticketing-comment"
            maxlength="100"
            formControlName="ticketingRequestComment"
          ></textarea>
        </form>
      </div>
    </div>
  </div>
</div>
